import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { StandbyGetAlternativeOffersModel } from './standby-get-alternative-offers.state';
import { PostStandbyGetAlternativeOffersResponse } from 'src/sdk_checkin';

/** StateDetailsActions */
const ACTION_SET = '[StandbyGetAlternativeOffers] set';
const ACTION_UPDATE = '[StandbyGetAlternativeOffers] update';
const ACTION_RESET = '[StandbyGetAlternativeOffers] reset';
const ACTION_FAIL = '[StandbyGetAlternativeOffers] fail';
const ACTION_CANCEL_REQUEST = '[StandbyGetAlternativeOffers] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[StandbyGetAlternativeOffers] set from api';
const ACTION_UPDATE_FROM_API = '[StandbyGetAlternativeOffers] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setStandbyGetAlternativeOffers = createAction(
  ACTION_SET,
  props<WithRequestId<StandbyGetAlternativeOffersModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateStandbyGetAlternativeOffers = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<StandbyGetAlternativeOffersModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetStandbyGetAlternativeOffers = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelStandbyGetAlternativeOffersRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failStandbyGetAlternativeOffers = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setStandbyGetAlternativeOffersFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostStandbyGetAlternativeOffersResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateStandbyGetAlternativeOffersFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostStandbyGetAlternativeOffersResponse>>()
);
